var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9999 1.5999C3.9999 0.937161 4.53716 0.399902 5.1999 0.399902C5.86264 0.399902 6.3999 0.937161 6.3999 1.5999V2.7999H13.5999V1.5999C13.5999 0.937161 14.1372 0.399902 14.7999 0.399902C15.4626 0.399902 15.9999 0.937161 15.9999 1.5999V2.7999H17.1999C18.5254 2.7999 19.5999 3.87442 19.5999 5.1999V17.1999C19.5999 18.5254 18.5254 19.5999 17.1999 19.5999H2.7999C1.47442 19.5999 0.399902 18.5254 0.399902 17.1999V5.1999C0.399902 3.87442 1.47442 2.7999 2.7999 2.7999H3.9999V1.5999ZM14.7151 9.49306C15.1255 9.0981 15.138 8.44527 14.743 8.03492C14.348 7.62457 13.6952 7.6121 13.2849 8.00706L8.28572 12.8187L6.71514 11.3071C6.30479 10.9121 5.65196 10.9246 5.257 11.3349C4.86204 11.7453 4.87451 12.3981 5.28486 12.7931L7.57058 14.9931C7.96988 15.3774 8.60155 15.3774 9.00086 14.9931L14.7151 9.49306Z",
    fill: "#399B6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheckGreen);
export default __webpack_public_path__ + "static/media/calendar-check-green.decf57afa226faa6f8636321d2df2e0a.svg";
export { ForwardRef as ReactComponent };